var s = (o, e, t) => {
  const r = e.lastIndexOf("?"), n = o[r === -1 || r < e.lastIndexOf("/") ? e : e.slice(0, r)];
  return n ? typeof n == "function" ? n() : Promise.resolve(n) : new Promise((i, l) => {
    (typeof queueMicrotask == "function" ? queueMicrotask : setTimeout)(l.bind(null, /* @__PURE__ */ new Error("Unknown variable dynamic import: " + e + (e.split("/").length !== t ? ". Note that variables only represent file names one level deep." : ""))));
  });
};
export {
  s as default
};
